import {Box, Chip, Grid, IconButton, Stack, Typography, Button} from "@mui/material";
import React, {useState} from "react";
import {NavLink, Outlet, useRevalidator, useRouteLoaderData} from "react-router-dom"; // Проверь, что useNavigate импортирован здесь
import ImageModal from '../../../../components/imageModal';
import ImageModalSingle from "../../../../components/imageModalSinglePhoto";
import PlaceholderedImage from "../../../../components/placeholderImage";

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import api from "../../../../hooks/useApi";
import PageTitle from "../../../../components/PageTitle";
import ObjectTransferDialog from '../../../../components/ObjectTransferDialog';
import {isSuperAdmin} from '../../../../auth/permissions';
import AuthProvider from '../../../../hooks/authProvider';

export default function ObjectDetails() {
    const layoutLoader = useRouteLoaderData('obj_layout');
    const hotelObj = layoutLoader.hotelObj;
    const user = layoutLoader.user || AuthProvider.user;
    const revalidator = useRevalidator();
    const [transferOpen, setTransferOpen] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(null);
    const [imageSrc, setImageSrc] = useState(null);
    const [imageSrcSingle, setImageSrcSingle] = useState(null);

    const handleNextImage = () => {
        setCurrentImageIndex((prevIndex) => {
            const nextIndex = prevIndex + 1 < hotelObj.hotel_image.length ? prevIndex + 1 : 0;
            return nextIndex;
        });
    };

    const handlePrevImage = () => {
        setCurrentImageIndex((prevIndex) => {
            const prevIndexNew = prevIndex - 1 >= 0 ? prevIndex - 1 : hotelObj.hotel_image.length - 1;
            return prevIndexNew;
        });
    };

    const handleDelete = async () => {
        try {
            const csrfToken = document.cookie
                .split('; ')
                .find((row) => row.startsWith('csrftoken'))
                ?.split('=')[1]; // Получение CSRF токена из куки

            const response = await fetch(`/api/HotelObj/${hotelObj.id}/`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken, // Добавляем CSRF токен, если он требуется
                },
            });

            if (response.statusText === 'No Content') {
                alert('Об\'єкт успішно видалено');
                window.location.href = '/calendar'; // Перенаправление после удаления, можно изменить на нужный маршрут
            } else {
                alert('Не вдалося видалити об\'єкт');
            }
        } catch (error) {
            //console.error('Помилка видалення:', error);
            alert('Виникла помилка при спробі видалити об\'єкт');
        }
    };

    const handleEdit = async (id) => {
        const newWindow = window.open('', '_blank');

        try {
            const url = `/no-nav/new-object/${id}/child/draft/${id}/?extraParam=HotelObjEdit`;
            newWindow.location.href = url; // Перенаправляем новое окно на нужный URL
            //console.log('new window updated');
        } catch (e) {
            alert("Помилка відкриття нового вікна: ", e);
            newWindow.close();
        }
    };

    const handleEditLocation = async (id, id_loc) => {
        const newWindow = window.open('', '_blank');

        try {
            const url = `/no-nav/new-object/${id}/location/draft/${id_loc}/update`;
            newWindow.location.href = url; // Перенаправляем новое окно на нужный URL
            //console.log('new window updated');
        } catch (e) {
            alert("Помилка відкриття нового вікна: ", e);
            newWindow.close();
        }
    };

    return (
        <>
            <PageTitle title={`Об'єкт: ${hotelObj?.name || hotelObj?.id || "деталі"}`} />
            {/* Декстопная версия */}
            <Box sx={{display: {xs: 'none', md: 'block'}, width: '100%'}}>
                <Stack direction="column" spacing={2}>
                    {/* Основной блок информации */}
                    <Grid container component={Box} sx={{alignItems: 'center'}}>
                        <Grid item xs={12} md={6}>
                            <Stack direction="column">
                                <Typography variant="h4" sx={{fontWeight: 'bold'}}>
                                    {hotelObj.name}{' '}
                                    <span style={{fontSize: '0.55em'}}>
                                        ({hotelObj.service_name})
                                    </span>
                                    <IconButton component={NavLink} to="edit/name">
                                        <EditOutlinedIcon/>
                                    </IconButton>
                                </Typography>
                                <Typography>
                                    Адреса: {hotelObj.location.text_address ?? hotelObj.location}{' '}
                                    <IconButton
                                        component={NavLink}
                                        onClick={() => {
                                            sessionStorage.setItem('location', JSON.stringify([hotelObj.id]));
                                            handleEditLocation(hotelObj.id, hotelObj.locationID);
                                        }}
                                    >
                                        <EditOutlinedIcon/>
                                    </IconButton>
                                </Typography>
                            </Stack>
                        </Grid>
                    </Grid>

                    {/* Изображения */}
                    <Stack direction="row" sx={{height: '150px'}} spacing={0.5}>
                        <Box
                            sx={{height: '100%', cursor: 'pointer'}}
                            onClick={() => {
                                setImageSrcSingle(hotelObj.image);
                            }}
                        >
                            <PlaceholderedImage
                                src={hotelObj.image}
                                style={{maxWidth: '100%', maxHeight: '100%', borderRadius: '15px'}}
                                alt={hotelObj.image}
                            />
                        </Box>
                        {hotelObj.hotel_image && (
                            <Grid container direction="column" spacing={0.5} sx={{width: 'fit-content'}}>
                                {hotelObj.hotel_image.map((el, index) => (
                                    <Grid item xs={4} key={index}>
                                        <Box
                                            sx={{
                                                height: '42px',
                                                width: '42px',
                                                position: 'relative',
                                                overflow: 'hidden',
                                                cursor: 'pointer',
                                            }}
                                            onClick={() => {
                                                setCurrentImageIndex(index);
                                            }}
                                        >
                                            <PlaceholderedImage
                                                src={el}
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    borderRadius: '15px',
                                                }}
                                                alt={el}
                                            />
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>
                        )}
                    </Stack>
                    {currentImageIndex !== null && (
                        <ImageModal
                            imageSrc={hotelObj.hotel_image[currentImageIndex]} // Текущее изображение
                            setImageSrc={setImageSrc}                      // Закрытие модального окна
                            handleNextImage={handleNextImage}              // Переход к следующему изображению
                            handlePrevImage={handlePrevImage}              // Переход к предыдущему изображению
                            resetCurrentImageIndex={() => setCurrentImageIndex(null)}
                            imageSingleDescriptions={hotelObj.image_descriptions_hotel_image[currentImageIndex]}
                        />
                    )}

                    {/* Описание */}
                    <Box>
                        <Stack direction="column">
                            <Typography variant="h5">
                                Опис{' '}
                                <IconButton component={NavLink} to="edit/descriptions">
                                    <EditOutlinedIcon/>
                                </IconButton>
                            </Typography>
                            <Typography variant="body">
                                <div dangerouslySetInnerHTML={{__html: hotelObj.descriptions}}></div>
                            </Typography>
                        </Stack>
                    </Box>

                    {/* Дополнительная информация */}
                    <Grid container>
                        <Grid item xs={6}>
                            <Stack direction="column">
                                <Typography variant="h5">
                                    Зручності{' '}
                                    <IconButton component={NavLink} to="edit/icons">
                                        <EditOutlinedIcon/>
                                    </IconButton>
                                </Typography>
                                <Typography variant="body">{hotelObj.icons.join(', ')}</Typography>
                            </Stack>
                        </Grid>
                        <Grid item xs={6}>
                            <Stack direction="column">
                                <Typography variant="h5">ID синхронізацій</Typography>
                                <Stack direction="column">
                                    <Typography variant="body">
                                        Hotels24: {hotelObj.hotels24_id}{' '}
                                        <IconButton component={NavLink} to="edit/hotels24_id">
                                            <EditOutlinedIcon/>
                                        </IconButton>
                                    </Typography>
                                    <Typography variant="body">
                                        Booking: {hotelObj.booking_id}{' '}
                                        <IconButton component={NavLink} to="edit/booking_id">
                                            <EditOutlinedIcon/>
                                        </IconButton>
                                    </Typography>
                                </Stack>
                            </Stack>
                        </Grid>
                    </Grid>

                    {/* Действия */}
                    <Box sx={{display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2}}>
                        {isSuperAdmin(user) && <Button variant="outlined" onClick={() => setTransferOpen(true)}>
                            Передати об’єкт
                        </Button>}
                        <Button variant="contained" color="error" startIcon={<DeleteIcon/>} onClick={handleDelete}>
                            Видалити Об'єкт
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<EditIcon/>}
                            onClick={() => handleEdit(hotelObj.id)}
                        >
                            Редагувати об'єкт
                        </Button>
                    </Box>
                </Stack>
            </Box>

            {/* Мобильная версия */}
            <Box sx={{display: {xs: 'block', md: 'none'}, width: '100%'}}>
                <Typography variant="h5" sx={{fontWeight: 'bold'}}>
                    {hotelObj.name}
                </Typography>
                <Typography>Адреса: {hotelObj.location.text_address ?? hotelObj.location}</Typography>
                <Box sx={{display: 'flex', justifyContent: 'center', my: 2}}>
                    <PlaceholderedImage
                        src={hotelObj.image}
                        style={{maxWidth: '100%', maxHeight: '200px', borderRadius: '15px'}}
                        alt={hotelObj.image}
                    />
                </Box>
                <Typography>
                    <strong>Опис:</strong>{' '}
                    <div dangerouslySetInnerHTML={{__html: hotelObj.descriptions}}></div>
                </Typography>
                <Box sx={{display: 'flex', justifyContent: 'space-between', mt: 2}}>
                    {isSuperAdmin(user) && <Button variant="outlined" onClick={() => setTransferOpen(true)}>
                        Передати
                    </Button>}
                    <Button variant="contained" color="primary" onClick={() => handleEdit(hotelObj.id)}>
                        Редагувати
                    </Button>
                    <Button variant="contained" color="error" onClick={handleDelete}>
                        Видалити
                    </Button>
                </Box>
            </Box>

            {imageSrcSingle && (
                <ImageModalSingle
                    imageSrcSingle={imageSrcSingle}
                    setImageSrcSingle={setImageSrcSingle}
                    imageSingleDescriptions={hotelObj.image_descriptions}
                />
            )}
            <ObjectTransferDialog
                open={transferOpen}
                onClose={() => setTransferOpen(false)}
                onTransferred={() => revalidator.revalidate()}
                objectId={hotelObj.id}
                objectName={hotelObj.name}
                currentOwner={hotelObj.owner}
                user={user}
            />
            <Outlet/>
        </>

    )
}
